import { Header, Table } from "@tanstack/react-table";

export const getPageNumbers = (totalPages: number, page: number) => {
  const pages: (string | number)[] = [];
  const maxVisiblePages = 5;

  if (totalPages <= maxVisiblePages) {
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
  } else {
    pages.push(1);

    let startPage = Math.max(2, page - 1);
    let endPage = Math.min(totalPages - 1, page + 1);

    if (page <= 3) {
      endPage = 4;
    }

    if (page >= totalPages - 2) {
      startPage = totalPages - 3;
    }

    if (startPage > 2) {
      pages.push("...");
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    if (endPage < totalPages - 1) {
      pages.push("...");
    }

    if (totalPages > 1) {
      pages.push(totalPages);
    }
  }

  return pages;
};

const calculateTotalColumns = <TData>(
  headers: Header<TData, unknown>[]
): number => {
  return headers.reduce((acc, header) => {
    if (header.subHeaders && header.subHeaders.length > 0) {
      return acc + calculateTotalColumns(header.subHeaders);
    }

    return acc + (header.isPlaceholder ? 0 : 1);
  }, 0);
};

export const getTotalColumnsCount = <TData>(table: Table<TData>): number => {
  const headerGroups = table.getHeaderGroups();

  if (!headerGroups.length) return 0;

  const lastHeaderGroup = headerGroups[headerGroups.length - 1];
  return calculateTotalColumns(lastHeaderGroup.headers);
};

export const getValueByPath = (obj: any, path: string): any => {
  if (!path) return undefined;

  return path.split(".").reduce((acc, part) => {
    if (!acc) return undefined;

    if (part.endsWith("[]")) {
      const key = part.replace("[]", "");
      const array = acc[key];

      return Array.isArray(array)
        ? array.map((item: any) => {
            return getValueByPath(
              item,
              path
                .split(".")
                .slice(path.indexOf(part) + 1)
                .join(".")
            );
          })
        : [];
    }

    return acc[part];
  }, obj);
};
